/**
* Created Info
* Created Command: npm run make-store global
* Created By: wanfeichao
* Created Date: Thu May 10 2018 16:01:17 GMT+0800 (CST)
*/
import actions from './_actions';
import mutations from './_mutations';
import state from './_state';
import types from './_types';

export default {
  actions,
  mutations,
  state,
  types
};



// WEBPACK FOOTER //
// ./src/stores/global/index.js